<template>
  <div id="app">
    <router-view></router-view>
    <LayoutSettings
      ref="layoutSettingsRef"
      @collapse-change="handleCollapseChange"
    />
  </div>
</template>

<script>
import LayoutSettings from "@/components/LayoutSettings.vue";

import { Local } from "@/utils/storage";
import watermark from "@/utils/watermark";

export default {
  name: "App",
  components: {
    LayoutSettings,
  },
  provide() {
    return {
      componentSize: this.componentSize,
    };
  },
  data() {
    return {
      navTabs: [], // 动态标签列表
      componentSize: "medium", // 组件大小：medium / small / mini
      isCollapsed: false, // 侧边栏是否折叠
      dateRange: [], // 时间范围
    };
  },

  
  mounted() {
    // 获取缓存中的布局配置（参考BlueWhaleWeb的实现）
    this.$nextTick(() => {
      const savedConfig = Local.get("themeConfig");
      if (savedConfig) {
        // 恢复保存的CSS变量样式（这是最关键的，必须最先执行）
        const savedStyle = Local.get("themeConfigStyle");
        if (savedStyle) {
          document.documentElement.style.cssText = savedStyle;
          
        }
        // 恢复深色模式
        if (savedConfig.isIsDark) {
          document.documentElement.setAttribute("data-theme", "dark");
        }
        // 恢复灰色模式和色弱模式
        if (savedConfig.isGrayscale || savedConfig.isInvert) {
          const cssAttr = savedConfig.isGrayscale
            ? `grayscale(${savedConfig.isGrayscale ? 1 : 0})`
            : `invert(${savedConfig.isInvert ? "80%" : "0%"})`;
          document.body.setAttribute("style", `filter: ${cssAttr}`);
        }
        // 恢复水印
        if (savedConfig.isWatermark && savedConfig.watermarkText) {
          setTimeout(() => {
            watermark.set(savedConfig.watermarkText);
          }, 300);
        }
        // 延迟应用渐变效果，确保DOM已渲染
        setTimeout(() => {
          if (this.$refs.layoutSettingsRef) {
            this.$refs.layoutSettingsRef.applyGradients(savedConfig);
          }
        }, 500);
      }
    });
    // 监听打开布局配置事件
    this.$root.$on("openLayoutSettings", () => {
      this.openLayoutSettings();
    });

  },
  beforeDestroy() {
    // 移除事件监听
    this.$root.$off("openLayoutSettings");
  },
  methods: {
    // 打开布局配置
    openLayoutSettings() {
      if (this.$refs.layoutSettingsRef) {
        this.$refs.layoutSettingsRef.openDrawer();
      }
    },
    // 处理布局配置的折叠变化
    handleCollapseChange(collapsed) {
      // 通过事件总线通知 home.vue
      this.$root.$emit("sidebar-collapse-change", collapsed);
    },
    // 处理时间范围变化
    handleDateChange(value) {
      
      // 这里可以处理时间范围变化后的逻辑
      // value 是格式化的数组，例如: ['2024-01-01 00:00:00', '2024-01-31 23:59:59']
      if (value && value.length === 2) {
        this.dateRange = value;
        // 可以在这里触发其他操作，比如更新数据等
      }
    },
  },
};
</script>
<style>
/*
 * 视口 CSS 宽度 ≤ 1920px 时（含常见 1080P 屏浏览器放大到约 125% 后宽度约 1536px）：
 * 由 html/body 承接横向滚动，避免布局被横向挤压变形。
 * 断点须与 home.vue 中 @media 保持一致。
 */
/* @media screen and (max-width: 1920px) {
  html,
  body {
    overflow-x: auto;
  }
} */

 /* .el-popper {
  min-width: 200px !important;

} */
 .el-select-dropdown{ 

  padding: 8px 12px;
 }
.el-table thead th {
  background-color: #f8f8f8 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--el-color-primary, #0f59a4) !important;
}

/* 深色模式 - 全局表格样式 */
[data-theme="dark"] .el-table {
  background-color: #1e2832 !important;
  color: #e0e0e0 !important;
}

[data-theme="dark"] .el-table thead th {
  background-color: #252f3d !important;
  color: #e0e0e0 !important;
  border-color: #3d4d5f !important;
}

[data-theme="dark"] .el-table__body tr {
  background-color: #1e2832 !important;
}

[data-theme="dark"] .el-table__body td {
  background-color: #1e2832 !important;
  border-color: #3d4d5f !important;
  color: #e0e0e0 !important;
}

[data-theme="dark"]
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td {
  background-color: #252f3d !important;
}

[data-theme="dark"] .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #2a3542 !important;
}

[data-theme="dark"] .el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: #2c3a49 !important;
  color: #e0e0e0 !important;
}

[data-theme="dark"]
  .el-pagination.is-background
  .el-pager
  li:not(.disabled):hover {
  color: var(--el-color-primary, #0f59a4) !important;
}

[data-theme="dark"]
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: var(--el-color-primary, #0f59a4) !important;
  color: #ffffff !important;
}

/* 时间选择器容器样式 */
.date-picker-container {
  position: fixed;
  top: 60px;
  right: 20px;
  z-index: 1000;
  width: 350px;
  background-color: #fff;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

[data-theme="dark"] .date-picker-container {
  background-color: #1e2832 !important;
  border: 1px solid #3d4d5f !important;
}
</style>
